var _path, _path2, _path3, _path4, _g, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyInWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.412 25.66h-5.525a1.988 1.988 0 0 1-1.988-1.987v-.124c0-1.098.89-1.988 1.988-1.988h5.525v4.1z",
    fill: "#31B59F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.39 12.833a2.408 2.408 0 0 1 2.408 2.407v13.684a2.84 2.84 0 0 1-2.84 2.84H4.53a2.84 2.84 0 0 1-2.84-2.84V15.672a2.84 2.84 0 0 1 2.84-2.84h.386",
    stroke: "#333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.788 19.094a2.746 2.746 0 0 1 2.747-2.746h24.413a2.746 2.746 0 0 1 2.747 2.746v9.799a2.747 2.747 0 0 1-2.747 2.746H4.535a2.747 2.747 0 0 1-2.747-2.746v-9.799z",
    stroke: "#333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 32,
    height: 18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.084 2.367H1.287v15.277a2.896 2.896 0 0 1 2.896-2.888H29.19c1.599 0 2.895 1.296 2.895 2.896v1.697V2.367z",
    fill: "#31B59F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.755 10.72a3.712 3.712 0 1 1-1.667-.609",
    stroke: "#333",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.353 16.48a2.33 2.33 0 0 1-.814.132 1.354 1.354 0 0 1-.517-.115c-.144-.064-.183-.242-.105-.38.091-.159.305-.197.48-.14.064.022.132.038.203.048.2.026.393.011.58-.044l-.565-1.624c-.18.016-.36.016-.537 0a1.922 1.922 0 0 1-.5-.12 1.228 1.228 0 0 1-.402-.268 1.244 1.244 0 0 1-.277-.47 1.239 1.239 0 0 1 .072-1.006c.081-.152.187-.287.318-.405a1.53 1.53 0 0 1 .438-.288l-.094-.268a.162.162 0 0 1 .307-.107l.093.269c.23-.08.471-.116.722-.108.15.004.29.028.424.071.16.052.21.24.13.389-.078.142-.26.184-.416.135a1.04 1.04 0 0 0-.188-.04 1.047 1.047 0 0 0-.498.051l.553 1.592c.19-.004.377-.002.56.006.185.007.356.039.513.094.16.05.302.131.423.247.126.114.225.275.297.484a1.266 1.266 0 0 1-.085 1.054 1.41 1.41 0 0 1-.33.409c-.14.12-.3.219-.478.295l.104.3a.163.163 0 0 1-.307.107l-.104-.3zM15.9 12.299a.942.942 0 0 0-.414.438.751.751 0 0 0-.01.57c.038.11.088.198.149.263a.727.727 0 0 0 .216.147c.083.033.173.057.268.071.099.009.204.015.315.02l-.524-1.509zm1.586 3.575a.962.962 0 0 0 .457-.438c.1-.192.115-.39.044-.595a.703.703 0 0 0-.168-.278.701.701 0 0 0-.249-.158 1.018 1.018 0 0 0-.3-.06 2.148 2.148 0 0 0-.32-.011l.536 1.54z",
    fill: "#31B59F"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.053,
    y: 10.821,
    width: 25.956,
    height: 14.32,
    rx: 0.895,
    transform: "rotate(-16.843 2.053 10.821)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2.053,
    y: 10.821,
    width: 25.956,
    height: 14.32,
    rx: 0.895,
    transform: "rotate(-16.843 2.053 10.821)",
    stroke: "#333",
    strokeWidth: 2,
    mask: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.013 10.377-2.048 4.048-.864-2.855a.298.298 0 0 1 .199-.372l2.713-.822zM23.403 4.995l3.95 2.233-.865-2.855a.298.298 0 0 0-.372-.199l-2.713.821z",
    fill: "#333",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.477 22.986-3.949-2.234.865 2.856a.298.298 0 0 0 .372.199l2.712-.821z",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.215 17.554 2.047-4.05.864 2.856a.298.298 0 0 1-.199.372l-2.712.822z",
    fill: "#333",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.403,
    cy: 16.008,
    r: 1.119,
    transform: "rotate(-16.843 10.403 16.008)",
    fill: "#31B59F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.823,
    cy: 12.248,
    r: 1.119,
    transform: "rotate(-16.843 22.823 12.248)",
    fill: "#31B59F"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.976 2.108 27.38.623M29.344 3.59l1.314-.799M24.184 2.186 23.455.831",
    stroke: "#31B59F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.741 .21)",
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyInWallet);
export default __webpack_public_path__ + "static/media/money-in-wallet.91f3098107265d763069ca5d6f6f926f.svg";
export { ForwardRef as ReactComponent };